import { render } from "./DialogReservationFailure.vue?vue&type=template&id=2c680806"
import script from "./DialogReservationFailure.vue?vue&type=script&lang=js"
export * from "./DialogReservationFailure.vue?vue&type=script&lang=js"
script.render = render

export default script